import { checkFeatureFlag } from '@/plugins/statsigClient';

export function useFeatureFlags() {
  const isFeatureEnabled = (featureName: string, defaultValue: boolean = false) => {
    return checkFeatureFlag(featureName, defaultValue);
  };

  return {
    isFeatureEnabled,
  };
}